var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85714 5.76224H24.1429C24.616 5.76224 25 5.3675 25 4.88112C25 4.39474 24.616 4 24.1429 4H1.85714C1.38571 4 1 4.39474 1 4.88112C1 5.3675 1.38571 5.76224 1.85714 5.76224ZM24.1429 11.049H8.71428C8.24286 11.049 7.85714 11.4437 7.85714 11.9301C7.85714 12.4164 8.24286 12.8112 8.71428 12.8112H24.1429C24.616 12.8112 25 12.4164 25 11.9301C25 11.4419 24.616 11.049 24.1429 11.049ZM24.1429 18.0961H1.85714C1.38571 18.0961 1 18.4908 1 18.9772C1 19.4636 1.38571 19.8583 1.85714 19.8583H24.1429C24.616 19.8583 25 19.4636 25 18.9772C25 18.4908 24.616 18.0961 24.1429 18.0961Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.f5194ab0bce6f1ef100f8cf11831385c.svg";
export { ForwardRef as ReactComponent };